import React, { useEffect, useRef } from 'react'
import mapboxgl from '!mapbox-gl'
import AroundControl from 'mapbox-gl-controls/lib/around'
import CompassControl from 'mapbox-gl-controls/lib/compass'
import ZoomControl from 'mapbox-gl-controls/lib/zoom'

mapboxgl.accessToken = 'pk.eyJ1IjoicGF0cmljaW9tYWNhZGRlbiIsImEiOiJjazhuam4zNzYwejcxM2xwaGdwMmI5a3Q5In0.qa5BBsZ94swjEXFBZMJEzw'

const ClientsMap = ({ geojson }) => {
  const map = useRef()
  const mapContainer = useRef()

  useEffect(() => {
    if (map.current) return

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/light-v10',
      zoom: 9
    })

    map.current.addControl(new ZoomControl(), 'bottom-right')
    map.current.addControl(new AroundControl(), 'bottom-right')
    map.current.addControl(new CompassControl(), 'bottom-right')

    map.current.on('load', () => {
      map.current.addSource('points', {
        type: 'geojson',
        data: geojson
      })

      map.current.addLayer({
        id: 'points',
        type: 'symbol',
        source: 'points',
        layout: {
          // get the icon name from the source's "icon" property
          // concatenate the name to get an icon from the style's sprite sheet
          'icon-image': ['concat', ['get', 'icon'], '-15'],
          // get the title name from the source's "title" property
          // 'text-field': ['get', 'title'],
          // 'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
          // 'text-offset': [0, 0.6],
          // 'text-anchor': 'top',
          'icon-allow-overlap': true
        }
      })

      map.current.on('click', 'points', e => {
        const coordinates = e.features[0].geometry.coordinates.slice()
        const infoWindow = e.features[0].properties.info_window

        // Ensure that if the map is zoomed out such that multiple
        // copies of the feature are visible, the popup appears
        // over the copy being pointed to.
        while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
          coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
        }

        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML(infoWindow)
          .addTo(map)
      })

      // Change the cursor to a pointer when the mouse is over the places layer.
      map.current.on('mouseenter', 'points', () => {
        map.current.getCanvas().style.cursor = 'pointer'
      })

      // Change it back to a pointer when it leaves.
      map.current.on('mouseleave', 'points', () => {
        map.current.getCanvas().style.cursor = ''
      })

      const coordinates = geojson.features.map(x => x.geometry.coordinates)

      const bounds = coordinates.reduce((bounds, coord) => bounds.extend(coord), new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]))

      map.current.fitBounds(bounds, {
        padding: 20
      })
    })
  })

  return (
    <div ref={mapContainer} style={{ height: '100%', width: '100%' }} />
  )
}

export default ClientsMap
